import React from 'react'
import { getIn } from 'formik'

import HeadlineText from '../../../../reusablePreviewComponents/HeadlineText'
import DescriptionText from '../../../../reusablePreviewComponents/DescriptionText'
import ActionButton from '../../../../reusablePreviewComponents/ActionButton'

import {
  AD_DESCRIPTION,
  AD_HEADLINE,
  CALL_TO_ACTION,
  CAROUSEL_ITEMS,
  DESCRIPTION_ENTER,
  DESCRIPTION_OPTION,
  HEADLINE_ENTER,
  HEADLINE_OPTION
} from '../../../../../../../forms/Facebook/AdForms/fields'

import useStyles from './styles'

const FacebookCarouselItemFooter = ({ formikValues, index, isActive }) => {
  const classes = useStyles()

  // ACTION BUTTON
  const actionValue = getIn(formikValues, `${CAROUSEL_ITEMS}[${index}].${CALL_TO_ACTION}`)

  // DESCRIPTION
  const descriptionText = getIn(formikValues, `${CAROUSEL_ITEMS}[${index}].${AD_DESCRIPTION}`)
  const descriptionEnter =
    getIn(formikValues, `${CAROUSEL_ITEMS}[${index}].${DESCRIPTION_OPTION}`) === DESCRIPTION_ENTER
  const descriptionIsInProgress = descriptionEnter && isActive

  // HEADLINE
  const headlineText = getIn(formikValues, `${CAROUSEL_ITEMS}[${index}].${AD_HEADLINE}`)
  const headlineEnter = getIn(formikValues, `${CAROUSEL_ITEMS}[${index}].${HEADLINE_OPTION}`) === HEADLINE_ENTER
  const headlineIsInProgress = headlineEnter && isActive

  return (
    <div className={classes.footer}>
      <div className={classes.info}>
        <HeadlineText
          headlineText={headlineText}
          isHeadlineBlank={!headlineEnter}
          isInProgress={headlineIsInProgress}
          className={classes.carouseHeadlineText}
          skeletonClassName={classes.skeletonCarouselHeadline}
          isCarousel
        />
        <DescriptionText
          descriptionText={descriptionText}
          isDescriptionBlank={!descriptionEnter}
          isInProgress={descriptionIsInProgress}
          className={classes.carouseDescriptionText}
          showSkeleton={true}
          skeletonClassName={classes.skeletonCarouselDescription}
        />
      </div>
      <ActionButton actionValue={actionValue} isInProgress={isActive} />
    </div>
  )
}

export default FacebookCarouselItemFooter
